import { useEffect, useState } from "react"
import { useGlobalContext } from "../../context/provider"
import { AxiosGetData } from "../../context/axiosfunction"
import SVGCoupon from "./SvgCoupon"

const MyCoupon = () => {
    const { API,headers,privateKey,Token} = useGlobalContext()
    const [userpone,setuserpone] = useState([])

    useEffect(()=>{
        const GetUserPone = async() => {
            const response = await AxiosGetData(API,'/api/checkauthent/getuser_pone',headers,privateKey)
            // console.log(response);
            if(response){
                const setform = response.map((data)=>({
                    cp_code:data.cp.cp_code,
                    cp_code_type: data.cp.cp_code_type,
                    cp_discount:data.cp.cp_discount,
                    cp_end:data.cp.cp_end,
                    cp_img:data.cp.cp_img,
                    cp_limit:data.cp.cp_limit,
                    cp_min_spend:data.cp.cp_min_spend,
                    cp_name:data.cp.cp_name,
                    status:data.cpu_status
                }))
                setuserpone(setform)
            }else{
                setuserpone([])
            }
        }
        if(Token){
        GetUserPone()

        }
    },[API,headers,privateKey,Token])
    // console.log(userpone);
    

    return(
        <div className="grid grid-cols-12 gap-[1.5em] pb-5">
            {userpone.length>0? 
                <>
                <h2 className="col-span-12 text-lg font-semibold my-3">🎉 คูปองของฉัน</h2>
                {userpone.map((data,index) =>                         
                    <div key={index} className=" col-span-12 sm:col-span-6 lg:col-span-4 relative mx-auto rounded-xl border-0 overflow-hidden">
                        <SVGCoupon data={data} page='user' />
                    </div>
                )}
                </>
            : 
                <div className="flex flex-col items-center gap-[2em] col-span-12">
                    <img className="w-[180px]" src="https://eve-image.eveebook.com/image.eveebook/mascot/no2.png" alt="" />
                    <div>คุณยังไม่มีคูปองที่เก็บไว้ เข้าไปรับได้ที่หน้าโปรโมชั่นเลยนะ</div>
                </div>
            }
            
        </div>
    )
}

export default MyCoupon